import React from "react";
import { Link } from "react-router-dom";
import { footerLinks } from "../mockData";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#08080f] border-t border-purple-900/20 pt-20 pb-8">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-10 mb-16">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <img src="/logo-white.png" alt="Digitronix Consultancy" className="h-12 w-auto" />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-sm">
              Digitronix Consultancy is a leading provider of cutting-edge digital solutions, specializing in web development, app development, AI, and business automation. With a strong presence globally, we empower businesses with innovative technology to streamline operations, enhance efficiency, and drive growth.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Quick Links</h4>
            <ul className="space-y-3">
              {footerLinks.quickLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-gray-400 text-sm hover:text-purple-400 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <h4 className="text-white font-semibold text-sm mt-6 mb-4">Products</h4>
            <ul className="space-y-3">
              <li><Link to="/products/chatro" className="text-gray-400 text-sm hover:text-purple-400 transition-colors">Chatro</Link></li>
              <li><Link to="/products/edusphere" className="text-gray-400 text-sm hover:text-purple-400 transition-colors">EduSphere</Link></li>
              <li><Link to="/products/teamsync" className="text-gray-400 text-sm hover:text-purple-400 transition-colors">TeamSync</Link></li>
              <li><Link to="/products/clientstream" className="text-gray-400 text-sm hover:text-purple-400 transition-colors">ClientStream</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="lg:col-span-2">
            <h4 className="text-white font-semibold text-sm mb-4">Services</h4>
            <div className="grid grid-cols-2 gap-x-10 gap-y-3">
              <Link to="/services/web-development" className="text-gray-400 text-sm hover:text-purple-400 transition-colors whitespace-nowrap">Web Development</Link>
              <Link to="/services/app-development" className="text-gray-400 text-sm hover:text-purple-400 transition-colors whitespace-nowrap">App Development</Link>
              {/* <Link to="/services/game-development" className="text-gray-400 text-sm hover:text-purple-400 transition-colors whitespace-nowrap">Game Development</Link> */}
              <Link to="/services/creative-designs" className="text-gray-400 text-sm hover:text-purple-400 transition-colors whitespace-nowrap">Creative Designs</Link>
              <Link to="/services/digital-marketing" className="text-gray-400 text-sm hover:text-purple-400 transition-colors whitespace-nowrap">Digital Marketing</Link>
              <Link to="/services/ai-development" className="text-gray-400 text-sm hover:text-purple-400 transition-colors whitespace-nowrap">AI Development</Link>
              <Link to="/services/content-marketing" className="text-gray-400 text-sm hover:text-purple-400 transition-colors whitespace-nowrap">Content Marketing</Link>
              <Link to="/services/blockchain-development" className="text-gray-400 text-sm hover:text-purple-400 transition-colors whitespace-nowrap">Blockchain</Link>
              <Link to="/services/erp-solutions" className="text-gray-400 text-sm hover:text-purple-400 transition-colors whitespace-nowrap">ERP Solutions</Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Qatar Office</h4>
            <ul className="space-y-3">
              <li className="text-gray-400 text-xs sm:text-sm whitespace-nowrap">info@digitronixconsultancyllc.com</li>
              <li className="text-gray-400 text-sm">380 Al Markhiya Street,<br/>Commercial Bank Plaza,<br/>Al Dafna, Doha, Qatar</li>
            </ul>
          </div>
        </div>

        {/* Marquee removed */}

        {/* Bottom */}
        <div className="border-t border-purple-900/20 pt-8 flex flex-col items-center gap-4 text-center">
          <span className="text-sm text-gray-500">Copyright &copy; 2026. All Rights Reserved.</span>
          <div className="flex items-center gap-4 text-sm text-gray-500">
            <Link to="/terms-conditions" className="hover:text-purple-400 transition-colors">Terms & Conditions</Link>
            <Link to="/privacy-policy" className="hover:text-purple-400 transition-colors">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
